import { render, staticRenderFns } from "./SwimLane.vue?vue&type=template&id=b3e28414&scoped=true"
import script from "./SwimLane.vue?vue&type=script&lang=js"
export * from "./SwimLane.vue?vue&type=script&lang=js"
import style0 from "./SwimLane.vue?vue&type=style&index=0&id=b3e28414&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e28414",
  null
  
)

export default component.exports